module.exports = __webpack_public_path__ + "static/media/advantage-4.5f34bda0.svg";